import { useState, useEffect } from 'react';
import Masonry from '@mui/lab/Masonry';
import { loadGallery } from './galleryCache';

function Paintings() {
  const [paintings, setPaintings] = useState([]);

  useEffect(() => {
    let cancelled = false;
    loadGallery('Paintings').then((records) => {
      if (cancelled) return;
      setPaintings(records);
    });
    return () => { cancelled = true; };
  }, []);

  return (
    <section id="paintings" className="min-h-screen pt-20 md:pt-32 px-4 md:px-0 md:ml-[25%] md:pr-8 pb-24 md:pb-8 bg-white">
      <Masonry
        columns={{ xs: 1, sm: 2, md: 3 }}
        spacing={2}
      >
        {paintings
          .filter((record) => {
            const { Attachments, Display } = record.fields;
            return Attachments?.[0] && Display;
          })
          .map((record, index) => {
            const { Attachments } = record.fields;
            const image = Attachments[0];
            const thumb = image.thumbnails?.large ?? image;

            return (
              <div key={record.id}>
                <img
                  src={thumb.url}
                  width={image.width}
                  height={image.height}
                  style={{ aspectRatio: `${image.width} / ${image.height}` }}
                  loading={index < 10 ? 'eager' : 'lazy'}
                  decoding="async"
                  alt="Painting"
                  className="w-full block"
                />
              </div>
            );
          })}
      </Masonry>
    </section>
  );
}

export default Paintings;
